import * as CookieConsent from 'vanilla-cookieconsent';
import 'vanilla-cookieconsent/dist/cookieconsent.css';

declare global {
  interface Window {
    gtag: (command: string, ...args: any[]) => void;
  }
}

export const initCookieConsent = () => {
  // Zawsze aktualizuj tę datę po zmianach w treści polityki prywatności
  const POLICY_VERSION = '2026-01-04';

  const logConsent = (cookie: { categories: string[]; consentId: string }) => {
    try {
      const URL = 'https://script.google.com/macros/s/AKfycbyrnJUqxRQzZWBddD9bT6NR6nXchJQwsEooJUmt4Vjmk8_gSnY6LufQyn8z3C9uZQ37/exec';

      fetch(URL, {
        method: 'POST',
        mode: 'no-cors',
        body: JSON.stringify({
          site: window.location.hostname,
          consentId: cookie.consentId,
          accepted: cookie.categories,
          userAgent: navigator.userAgent,
          policyVersion: POLICY_VERSION
        })
      }).catch(err => console.warn('Consent log failed:', err));
    } catch (e) {
      // Ciche logowanie błędu, aby nie straszyć użytkownika
      console.error('Consent logging failed', e);
    }
  };

  CookieConsent.run({
    revision: 1,
    guiOptions: {
      consentModal: {
        layout: 'box',
        position: 'bottom right',
        equalWeightButtons: true,
        flipButtons: false
      },
      preferencesModal: {
        layout: 'box',
        position: 'right',
        equalWeightButtons: true,
        flipButtons: false
      }
    },
    // CALLBACKS
    onFirstConsent: ({ cookie }) => {
      // Logowanie zgody
      logConsent(cookie);
    },
    onChange: ({ cookie }) => {
      // Logowanie zmiany zgody
      logConsent(cookie);
    },
    categories: {
      necessary: {
        readOnly: true,
        enabled: true
      },
      analytics: {
        autoClear: {
          cookies: [
            {
              name: /^_ga/,   // regex: match all cookies starting with '_ga'
            },
            {
              name: '_gid',   // string: exact cookie name
            }
          ]
        },
        services: {
          ga4: {
            label: 'Google Analytics 4',
            onAccept: () => {
              // Enable Google Analytics
              console.log('ga4 accepted');
              if (typeof window.gtag === 'function') {
                window.gtag('consent', 'update', {
                  analytics_storage: 'granted',
                  ad_storage: 'granted',
                  ad_user_data: 'granted',
                  ad_personalization: 'granted'
                });
              }
            },
            onReject: () => {
              // Disable Google Analytics
              console.log('ga4 rejected');
              if (typeof window.gtag === 'function') {
                window.gtag('consent', 'update', {
                  analytics_storage: 'denied',
                  ad_storage: 'denied',
                  ad_user_data: 'denied',
                  ad_personalization: 'denied'
                });
              }
            }
          }
        }
      }
    },
    language: {
      default: 'en',
      translations: {
        en: {
          consentModal: {
            title: 'We use cookies',
            description: 'This website uses essential cookies to ensure its proper operation and tracking cookies to understand how you interact with it. The latter will be set only after consent.',
            acceptAllBtn: 'Accept all',
            acceptNecessaryBtn: 'Reject all',
            showPreferencesBtn: 'Manage preferences',
            footer: `
              <a href="/privacy-policy" target="_blank">Privacy Policy</a>
              <a href="/terms" target="_blank">Terms</a>
            `
          },
          preferencesModal: {
            title: 'Consent Preferences Center',
            acceptAllBtn: 'Accept all',
            acceptNecessaryBtn: 'Reject all',
            savePreferencesBtn: 'Save preferences',
            closeIconLabel: 'Close modal',
            sections: [
              {
                title: 'Cookie Usage',
                description: 'I use cookies to ensure the basic functionalities of the website and to enhance your online experience. You can choose for each category to opt-in/out whenever you want.'
              },
              {
                title: 'Strictly Necessary Cookies',
                description: 'These cookies are essential for the proper functioning of my website. Without these cookies, the website would not work properly.',
                linkedCategory: 'necessary'
              },
              {
                title: 'Performance and Analytics Cookies',
                description: 'These cookies allow the website to remember the choices you have made in the past.',
                linkedCategory: 'analytics',
                cookieTable: {
                  headers: {
                    name: 'Name',
                    domain: 'Service',
                    description: 'Description',
                    expiration: 'Expiration'
                  },
                  body: [
                    {
                      name: '_ga',
                      domain: 'Google Analytics',
                      description: 'Used to distinguish users.',
                      expiration: '2 years'
                    },
                    {
                      name: '_gid',
                      domain: 'Google Analytics',
                      description: 'Used to distinguish users.',
                      expiration: '24 hours'
                    }
                  ]
                }
              }
            ]
          }
        }
      }
    }
  });
};

export const showConsentSettings = () => {
  try {
    CookieConsent.showPreferences();
  } catch (err) {
    console.error('Failed to show cookie preferences:', err);
  }
};
